import { BedDouble, Check } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { STRUCTURES, scrollToId } from "@/data/content";

const Strutture = () => (
  <section id="strutture" data-testid="strutture-section" className="bg-beige py-24 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        chapter="02"
        eyebrow="Le Nostre Strutture"
        title="Tre residenze, un'unica cura"
        text="Tre residenze differenti per rispondere alle diverse esigenze degli ospiti e delle loro famiglie. Totale capacità ricettiva: 46 posti letto."
        testid="strutture-heading"
      />

      <div className="mt-16 grid gap-10 lg:grid-cols-3 lg:gap-8">
        {STRUCTURES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.12} className={i === 1 ? "lg:mt-14" : ""}>
            <article
              data-testid={`structure-card-${s.id}`}
              className="group flex h-full flex-col overflow-hidden rounded-[2rem] bg-ivory shadow-sm transition-shadow duration-500 hover:shadow-2xl hover:shadow-sage/10"
            >
              <div className="relative overflow-hidden">
                <img
                  src={s.image}
                  alt={`${s.name} — ${s.tagline}`}
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-ivory/90 px-3.5 py-1.5 text-xs font-semibold text-sage backdrop-blur">
                  <BedDouble size={14} />
                  {s.beds} posti letto
                </span>
              </div>
              <div className="flex flex-1 flex-col p-7">
                <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-wood">{s.tagline}</p>
                <h3 className="mt-2 font-serif text-3xl font-medium text-ink">{s.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-moss">{s.desc}</p>
                <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-[13px] text-moss">
                      <Check size={14} className="mt-0.5 shrink-0 text-sage" />
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`structure-visit-${s.id}`}
                  onClick={() => scrollToId("contatti")}
                  className="mt-7 self-start text-sm font-semibold text-sage underline-offset-4 transition-colors hover:text-terracotta hover:underline"
                >
                  Prenota una visita →
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Strutture;
